import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.state';
import { removeAnnex, setCalculateAccessories, setMeasurements, updateRainSystem } from '../../calculation.actions';
import { map } from 'rxjs/operators';
import { CalculationState, selectCalculation } from '../../calculation.state';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AnnexModalComponent } from './annex-modal/annex-modal.component';
import { MeasurementsType } from './measurements.constants';
import { roofTypes } from '../../../localization/locale/ro/roof-types';
import { AnnexModalDataInterface } from './annex-modal/annex.constants';
import { FormEvent } from '../../../common/shared/constants';
import { rainSystemDefaultState } from './rain-system/rain-system.constants';
import { Subscription } from 'rxjs';
import { RainSystemMeasurementsDto } from '../../../../api/models/rain-system-measurements-dto';
import { ConfirmDialogComponent } from '../../../common/shared/confirm-dialog/confirm-dialog.component';
import { CoreComponent } from '../../../core.component';
import { ContactMeDialogComponent } from '../../../cart/contact-me-dialog/contact-me-dialog.component';
import { CalculationTypeEnum } from '../../../../api/models';

@Component({
  selector: 'measurements-common',
  templateUrl: './measurements.component.html',
  styleUrls: ['./measurements.component.scss'],
})
export class MeasurementsComponent extends CoreComponent implements OnInit, OnDestroy {
  rainSystemFormEvent: FormEvent<RainSystemMeasurementsDto> = { valid: true, value: rainSystemDefaultState };
  measurementsFormEvent: FormEvent<MeasurementsType | null> = { valid: false, value: null };
  private storeSubscription!: Subscription;
  activeCalculation!: CalculationState;
  roofTypesLocalized = roofTypes;
  roofTypes = CalculationTypeEnum;
  rainSystem = false;

  constructor(private readonly store: Store<AppState>, private readonly dialog: MatDialog) {
    super();
  }

  ngOnInit(): void {
    this.storeSubscription = this.store.pipe(map((state) => selectCalculation(state))).subscribe((calculation) => {
      this.activeCalculation = calculation;
      if (this.activeCalculation.rainSystem && this.activeCalculation.rainSystem.rainSystem !== this.rainSystem) {
        this.rainSystem = this.activeCalculation.rainSystem.rainSystem;
      }
    });
  }
  ngOnDestroy(): void {
    this.storeSubscription?.unsubscribe();
  }

  setRainSystem(rainSystem: FormEvent<RainSystemMeasurementsDto>) {
    if (rainSystem.valid && !rainSystem.unchanged) {
      this.store.dispatch(
        updateRainSystem({
          groundToEavesHeight: rainSystem.value.groundToEavesHeight,
          eavesDescents: rainSystem.value.eavesDescents,
          rainSystem: this.rainSystem,
        }),
      );
    }
    this.rainSystemFormEvent = rainSystem;
  }

  setMeasurements(measurements: FormEvent<MeasurementsType>) {
    if (measurements.valid && !measurements.unchanged) {
      this.store.dispatch(setMeasurements({ measurements: measurements.value }));
    }
    this.measurementsFormEvent = measurements;
  }

  setCalculateAccessories() {
    if (this.measurementsFormEvent.valid && this.rainSystemFormEvent.valid) {
      if (this.activeCalculation.accessories?.length) {
        this.dialog.open(ConfirmDialogComponent, {
          data: {
            title: 'Aveți accesorii salvate pe calcul, doriți să le recalculăm ?',
            okBtnText: 'Da',
            cancelBtnText: 'Nu',
            okCallback: async () => {
              this.store.dispatch(setCalculateAccessories({ calculateAccessories: true }));
            },
          },
        });
      } else {
        this.store.dispatch(setCalculateAccessories({ calculateAccessories: true }));
      }
    }
  }

  get roofType(): CalculationTypeEnum {
    return this.activeCalculation.roofType;
  }

  removeAnnex(index: number) {
    return this.store.dispatch(removeAnnex({ index }));
  }

  openDialog(index?: number) {
    const config: MatDialogConfig<AnnexModalDataInterface> = {
      width: '100%',
      minWidth: '100%',
      minHeight: '90%',
      height: '90%',
      data: { index: 0 },
    };
    if (index !== undefined) {
      config.data = {
        index,
        annex: this.activeCalculation.annexes[index],
      };
    }
    this.dialog.open(AnnexModalComponent, config);
  }

  changeRainSystemToggle(checked: boolean) {
    this.rainSystem = checked;
    this.store.dispatch(updateRainSystem({ rainSystem: this.rainSystem }));
  }

  openContactMeDialog(): void {
    this.dialog.open(ContactMeDialogComponent, {
      width: '350px',
      data: null,
    });
  }
}
